import { render } from "./PrizeCard.vue?vue&type=template&id=2842577b&scoped=true"
import script from "./PrizeCard.vue?vue&type=script&lang=js"
export * from "./PrizeCard.vue?vue&type=script&lang=js"

import "./PrizeCard.vue?vue&type=style&index=0&id=2842577b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2842577b"]])

export default __exports__